'use strict';
import Megatron from '@stencil/megatron';
import {apiConfig} from '@stencil/hotels-config';

const prepareHolidayCalendarApiRequest = () => {
  return `${apiConfig.__VOYAGER__}/api/v1/pagemaker/get_rendered_template/?template_ids=["calendar_json"]`;
};

export async function getHolidayCalendarApi() {
  const url = prepareHolidayCalendarApiRequest();
  const response = await Megatron({
    name: 'Fetch Hotels Holiday Calendar',
    type: 'GET',
    url,
    credentials: 'same-origin',
  });
  return response;
}

export default getHolidayCalendarApi;
